import React from 'react';
import { currency } from '@utils';
import { baseURL } from '@services/env-variables';
import { useSelector } from 'react-redux';

export const ResumoRecibmento = ({ dadosIniciais }) => {
  const { matricula, token, nome } = useSelector((state) => state.user);

  return (
    <div>
      <div className="row mt-4 mb-4 ">
        <h2 className="mb-2">
          <strong>Resumo da opção</strong>
        </h2>
        <div className="col-12 col-md-6 col-lg-4 mt-2">
          <p className="text-orange fw-bold ts-20">Valor reserva matemática</p>
          <p className="text-muted fw-bold ts-18 mt-2">
            {currency(dadosIniciais.reservaMatematica)}
          </p>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mt-2">
          <p className="text-orange fw-bold ts-20">Data Solicitação</p>
          <p className="text-muted fw-bold ts-18 mt-2">
            {dadosIniciais.dataSolicitacao}
          </p>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mt-2">
          <p className="text-orange fw-bold ts-20">Status</p>
          <p className="text-muted fw-bold ts-18 mt-2">
            {dadosIniciais.statusSolicitacao}
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-6 col-lg-4 mt-2">
          <p className="text-orange fw-bold ts-20">
            Percentual recebimento solicitado
          </p>
          <p className="text-muted fw-bold ts-18 mt-2">
            {dadosIniciais.percentualRecebimento}
          </p>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mt-2">
          <p className="text-orange fw-bold ts-20">
            Valor estimado da renda mensal inicial após transformação
          </p>
          <p className="text-muted fw-bold ts-18 mt-2">
            {currency(dadosIniciais.valorRendaPosTransf)}
          </p>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mt-2">
          <p className="text-orange fw-bold ts-20">Protocolo</p>
          <p className="text-muted fw-bold ts-18 mt-2">
            {dadosIniciais.protocolo}
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-6 col-lg-8 mt-32" />
        <div className="col-12 col-md-6 col-lg-4 mt-32">
          <a
            href={`${baseURL}GerarResumoTransformacaoBeneficio?matricula=${matricula}&token=${token}&nome=${nome}&beneficio=${dadosIniciais.tipoBeneficio}&protocolo=${dadosIniciais.protocolo}&forma=${dadosIniciais.formaRecebimento}&dtSol=${dadosIniciais.dataSolicitacao}&percentual=${dadosIniciais.percentualRecebimento}&qtdFamiliar=${dadosIniciais.pessoasGrupoFamiliar}&tipo=${dadosIniciais.tipoBeneficio}`}
            rel="noreferrer"
            target="_blank"
            download
            title="Clique para baixar o pdf do protocolo"
            className=" mt-2 aButtonTransparent"
          >
            Gerar PDF
          </a>
        </div>
      </div>
    </div>
  );
};
